import { useMemo } from "react";
import {
  DEFAULT_MIN_TICKET_PURCHASE_LIMIT,
  DEFAULT_MAX_TICKET_PURCHASE_LIMIT,
} from "@shared/constants/common";

export default function useItemQuantitySelect(min?: number, max?: number) {
  const selectOptions = useMemo(() => {
    // regardless of min and max, 0 should be an option
    const options = [{ id: 0, name: "0" }];
    const minimum = min ?? DEFAULT_MIN_TICKET_PURCHASE_LIMIT;
    const maximum = max ?? DEFAULT_MAX_TICKET_PURCHASE_LIMIT;

    for (let i = minimum; i <= maximum; i += 1) {
      options.push({
        id: i,
        name: String(i),
      });
    }

    return options;
  }, [min, max]);

  return { selectOptions };
}
